import React from 'react';
import { Box, Grid, Typography, Stack, Input, InputLabel, TextField, Select, MenuItem, FormHelperText, FormControl } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ArrowForward } from '@mui/icons-material';
import FlowChart from './FlowChart';
import Navbar from '../Auth/Navbar';

function FormInfoHousePage() {
    // Syria cities list
    const syriaCities = [
        "دمشق", "حلب", "اللاذقية", "حمص", "دير الزور", "الرقة",
        "إدلب", "طرطوس", "حماه", "درعا", "القنيطرة", "السويداء",
        "المصياف", "النبك"
    ];

    return (
        <>
            <Navbar />

            <Stack sx={{ backgroundColor: "#eee", textAlign: "center", minHeight: "90vh", borderRadius: "6px" }} alignItems={"center"} justifyContent={"center"}>
                <Stack sx={{ backgroundColor: "#FFF", minHeight: "80vh", borderRadius: "6px", width: { xs: "95%", sm: "85%" }, m: 4, p: 4 }}>
                    <Grid container justifyContent={"space-between"} spacing={2}>
                        <Grid item xs={12} sm={2}>
                            <FlowChart index={2} />
                        </Grid>
                        <Grid item xs={12} sm={8} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                            <Typography variant='h5' sx={{ fontWeight: "bold", p: 1, textAlign: "right", display: 'flex', flexDirection: "row-reverse" }}>
                                <span>-2</span>
                                معلومات العقار
                            </Typography>
                            <form>
                                <Grid container spacing={2} justifyContent={"space-between"}>
                                    <Grid item xs={12} sm={5}>
                                        {/* محافظة تواجد العقار */}
                                        <FormControl fullWidth variant="outlined" margin="normal" sx={{ direction: 'rtl' }}>
                                            <InputLabel>محافظة تواجد العقار</InputLabel>
                                            <Select
                                                label="محافظة"
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'محافظة' }}
                                                value="سوريا"
                                                disabled
                                            >
                                                <MenuItem value="سوريا">
                                                    <em>سوريا</em>
                                                </MenuItem>
                                            </Select>
                                        </FormControl>

                                        {/* منطقة تواجد العقار */}
                                        <FormControl fullWidth variant="outlined" margin="normal" sx={{ direction: 'rtl' }}>
                                            <InputLabel>منطقة تواجد العقار</InputLabel>
                                            <Select
                                                label="منطقة"
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'منطقة' }}
                                            >
                                                <FormHelperText>قم باختيار عنصر من القائمة</FormHelperText>
                                                <MenuItem>قم باختيار عنصر من القائمة</MenuItem>
                                            </Select>
                                        </FormControl>

                                        {/* نوع العقار */}
                                        <FormControl fullWidth variant="outlined" margin="normal" sx={{ direction: 'rtl' }}>
                                            <InputLabel>نوع العقار</InputLabel>
                                            <Select
                                                label="نوع العقار"
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'نوع العقار' }}
                                            >
                                                <FormHelperText>قم باختيار عنصر من القائمة</FormHelperText>
                                                <MenuItem>قم باختيار عنصر من القائمة</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <TextField
                                            fullWidth
                                            label="عدد الغرف أو الفراغات (اختياري)"
                                            placeholder="قم بادخال عدد الغرف أو الفراغات"
                                            variant="outlined"
                                            margin="normal"
                                            sx={{ direction: 'rtl' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        {/* مدينة تواجد العقار */}
                                        <TextField
                                            fullWidth
                                            label="مدينة تواجد العقار"
                                            select
                                            value=""
                                            onChange={() => { }}
                                            SelectProps={{
                                                native: true,
                                            }}
                                            variant="outlined"
                                            margin="normal"
                                            sx={{ direction: 'rtl' }}
                                        >
                                            <option value="">قم باختيار مدينة</option>
                                            {syriaCities.map((city, index) => (
                                                <option key={index} value={city}>
                                                    {city}
                                                </option>
                                            ))}
                                        </TextField>

                                        {/* رقم العقار */}
                                        <TextField
                                            fullWidth
                                            label="رقم العقار (إن وجد)"
                                            placeholder="قم بادخال رقم العقار بحال توفره"
                                            variant="outlined"
                                            margin="normal"
                                            sx={{ direction: 'rtl' }}
                                        />

                                        {/* مساحة العقار */}
                                        <TextField
                                            fullWidth
                                            label="(m²) مساحة العقار"
                                            placeholder="قم بادخال مساحة العقار بالمتر المربع"
                                            variant="outlined"
                                            margin="normal"
                                            sx={{ direction: 'rtl' }}
                                        />

                                        {/* عمر العقار */}
                                        <TextField
                                            fullWidth
                                            label="عمر العقار"
                                            placeholder="قم بادخال العمر التقديري للعقار بالسنوات"
                                            variant="outlined"
                                            margin="normal"
                                            sx={{ direction: 'rtl' }}
                                        />
                                    </Grid>
                                </Grid>
                            </form>
                        </Grid>

                        <Stack direction={"row"} justifyContent={"end"} alignItems={"center"} sx={{ width: "100%", gap: 2, my: 4 }}>
                            <Link to={"/InputInfoDesc"} className='btnLink'>
                                <ArrowBackIcon sx={{ mt: 1 }} />التالي
                            </Link>
                            <Link to="/InputInfoPersonal" className='LinkbtnBack'>
                                رجوع
                                <ArrowForward sx={{ mt: 1 }} />
                            </Link>
                        </Stack>
                    </Grid>
                </Stack>
            </Stack>
        </>
    );
}

export default FormInfoHousePage;
